<script setup>
import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();
const companyAddresses = ref([
  {
    country: "USA Office",
    icon: "/images/USAicon.webp",
    darkIcon: "/images/darkModeUSAImg.webp",
    companyAddress: "7858, 1021 E Lincolnway, Cheyenne, WY, Laramie, US, 82001",
    contactNo: " +1 (502) 287-0005",
    mail: "we@webreinvent.com",
    altText: "WebReinvent Location Icon",
  },
  {
    country: "India Office",
    icon: "/images/INDIAicon.webp",
    darkIcon: "/images/darkModeINDImg.webp",
    companyAddress:
      "2nd Floor, Plot 6, Apex Square 3, Pocket B 3, Sector 17, Dwarka, Delhi, India 110075",
    contactNo: "+91 858 886 4948 / 012 0313 4356",
    mail: "we@webreinvent.com",
    altText: "WebReinvent Location Icon",
  },
]);
</script>
<template>
  <template v-for="address in companyAddresses" :key="address.country">
    <div
      class="md:max-w-[667px] w-full p-px dark:bg-[linear-gradient(91.95deg,rgba(98,69,116,0.7)_4.5%,rgba(122,84,157,0.7)_96.91%)] bg-[linear-gradient(91.95deg,rgba(242,242,242,0.7)_4.5%,rgba(204,204,204,0.7)_96.91%)] rounded-xl"
    >
      <div
        class="flex gap-8 items-center md:justify-center bg-[image:var(--bg-official-partner)] lg:py-10 py-4 lg:pl-12 pl-4 lg:pr-24 pr-10 rounded-xl h-full shadow-[3px_23px_52px_-2px_rgba(0,0,0,0.05)]"
      >
        <NuxtImg
          alt="Address Icon"
          :src="$colorMode.preference== 'dark' ? address.darkIcon : address.icon"
          class="shrink-0"
          height="112"
          width="83"
          loading="lazy"
          format="webp"
        />

        <div class="flex flex-col">
          <h3 class="text-xl font-semibold">{{ address.country }}</h3>
          <div class="mt-[26px]">
            <p class="text-base tracking-[0.5px]">
              {{ address.companyAddress }}
            </p>
            <p class="text-base font-semibold mt-3">
              {{ address.contactNo }}
            </p>
            <p
              class="text-[rgba(175,102,228,1)] mt-1 font-semibold tracking-[0.5px]"
            >
              {{ address.mail }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>
